import en from "./en.json"
import it from "./it.json"

const languages = {
    en,
    it
}

export default languages
